"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPolicy = exports.eOrinocoTerms = exports.eProductType = void 0;
const MasterPolicyEndorsement_class_1 = require("./MasterPolicyEndorsement.class");
const MasterPolicyInsuranceLicense_class_1 = require("./MasterPolicyInsuranceLicense.class");
const date_fns_1 = require("date-fns");
const countries_1 = require("../countries");
var eProductType;
(function (eProductType) {
    eProductType["USA"] = "Thames USA";
    eProductType["CANADA"] = "Thames Canada";
    eProductType["ORINOCO"] = "Orinoco";
    eProductType["EUROPE"] = "Thames Europe";
})(eProductType = exports.eProductType || (exports.eProductType = {}));
var eOrinocoTerms;
(function (eOrinocoTerms) {
    eOrinocoTerms["DED"] = "DED_";
    eOrinocoTerms["LOADSURE"] = "loadsure";
})(eOrinocoTerms = exports.eOrinocoTerms || (exports.eOrinocoTerms = {}));
class MasterPolicy {
    constructor(partner, insuranceLicense, policyType, period, limit, endorsements, binder, productType, googleDriveFileId) {
        this.partner = partner;
        this.insuranceLicense = insuranceLicense;
        this.policyType = policyType;
        this.period = period;
        this.limit = limit;
        this.endorsements = endorsements;
        this.binder = binder;
        this.productType = productType;
        this.googleDriveFileId = googleDriveFileId;
    }
    static fromObj(data) {
        var _a;
        return new MasterPolicy(data.partner, MasterPolicyInsuranceLicense_class_1.MasterPolicyInsuranceLicense.fromObj(data.insuranceLicense), data.policyType, data.period, data.limit, ((_a = data.endorsements) !== null && _a !== void 0 ? _a : []).map(MasterPolicyEndorsement_class_1.MasterPolicyEndorsement.fromObj), data.binder, data.productType, data.googleDriveFileId);
    }
    static getMasterPolicyName(partnerId, startDate) {
        return `Loadsure - Master Policy - ${partnerId} - ${startDate}`;
    }
    get masterPolicyName() {
        return MasterPolicy.getMasterPolicyName(this.partner.id, this.period.startDate);
    }
    get status() {
        return this.period.in(new Date());
    }
    getLastEndorsementType(type) {
        const endorsements = this.endorsements.filter((endorsement) => endorsement.type === type);
        if (endorsements.length) {
            return endorsements[endorsements.length - 1];
        }
        return undefined;
    }
    get activeInsuranceLicense() {
        var _a, _b;
        const lastEndorsement = this.getLastEndorsementType(MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.LICENSE_CHANGE);
        if (lastEndorsement) {
            return (((_a = lastEndorsement.change) === null || _a === void 0 ? void 0 : _a.new) || ((_b = lastEndorsement.insuranceLicense) === null || _b === void 0 ? void 0 : _b.new));
        }
        return this.insuranceLicense;
    }
    get activePartnerAddress() {
        var _a;
        const lastEndorsement = this.getLastEndorsementType(MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.PARTNER_ADDRESS_CHANGE);
        if (lastEndorsement) {
            return (_a = lastEndorsement.change) === null || _a === void 0 ? void 0 : _a.new;
        }
        return this.partner.address;
    }
    get activePartnerName() {
        var _a;
        const lastEndorsement = this.getLastEndorsementType(MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.PARTNER_NAME_CHANGE);
        if (lastEndorsement) {
            return (_a = lastEndorsement.change) === null || _a === void 0 ? void 0 : _a.new;
        }
        return this.partner.name;
    }
    getLicenseAndEffectiveDate() {
        var _a, _b;
        const lastEndorsement = this.getLastEndorsementType(MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.LICENSE_CHANGE);
        if (lastEndorsement) {
            return {
                license: ((_a = lastEndorsement.change) === null || _a === void 0 ? void 0 : _a.new) || ((_b = lastEndorsement.insuranceLicense) === null || _b === void 0 ? void 0 : _b.new),
                effectiveDate: lastEndorsement.effectiveDate
            };
        }
        return {
            license: this.insuranceLicense,
            effectiveDate: this.period.startDate
        };
    }
    assignProductType(country, coverageId) {
        this.productType = MasterPolicy.getProductType(country, coverageId);
    }
    static getProductType(country, coverageId) {
        const lowerCaseCoverageId = coverageId.toLowerCase();
        const isLoadsureCoverage = Object.values(eOrinocoTerms).some((term) => lowerCaseCoverageId.includes(term.toLowerCase()));
        if (!isLoadsureCoverage && coverageId) {
            return eProductType.ORINOCO;
        }
        if (country === "CAN") {
            return eProductType.CANADA;
        }
        if (countries_1.isEuropeanCountry(country)) {
            return eProductType.EUROPE;
        }
        return eProductType.USA;
    }
    get hasEndorsementsInsurersChange() {
        return this.endorsements.some((endorsement) => endorsement.type ===
            MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.PARTICIPATING_INSURERS_CHANGE);
    }
    getLastInsurersChangeEndorsement(date) {
        let endorsementsApplicable;
        if (date)
            endorsementsApplicable = this.endorsements.filter((endorsement) => !date_fns_1.isBefore(new Date(date), new Date(endorsement.effectiveDate)) &&
                endorsement.type ===
                    MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.PARTICIPATING_INSURERS_CHANGE);
        else
            endorsementsApplicable = this.endorsements.filter((endorsement) => endorsement.type ===
                MasterPolicyEndorsement_class_1.eMasterPolicyEndorsementType.PARTICIPATING_INSURERS_CHANGE);
        const endorsementsSorted = endorsementsApplicable.sort((e1, e2) => {
            if (e1.effectiveDate > e2.effectiveDate)
                return 1;
            if (e1.effectiveDate < e2.effectiveDate)
                return -1;
            return 0;
        });
        const recentestEndorsement = endorsementsSorted[endorsementsSorted.length - 1];
        return recentestEndorsement.change.new;
    }
    static getMasterPolicyByDate(masterPolicies, date) {
        const masterPolicyApplied = masterPolicies.filter((mp) => date_fns_1.isWithinInterval(new Date(date), {
            start: new Date(mp.period.startDate),
            end: new Date(mp.period.endDate)
        }));
        return masterPolicyApplied === null || masterPolicyApplied === void 0 ? void 0 : masterPolicyApplied[0];
    }
    getBinderInsurers(date) {
        if (this.hasEndorsementsInsurersChange)
            return this.getLastInsurersChangeEndorsement(date);
        return this.binder.participartingInsurers;
    }
}
exports.MasterPolicy = MasterPolicy;
//# sourceMappingURL=MasterPolicy.class.js.map